import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { COLORS } from "constants/colors";

function ChiEpisodeError() {
  const [t, i18n] = useTranslation(["chi"]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <SearchOffIcon sx={{ fontSize: "100px", color: COLORS.TEXT_WHITE }} />
      <Typography
        variant="h6"
        sx={{
          marginTop: "16px",
          color: COLORS.TEXT_WHITE,
          fontSize: "16px",
          fontWeight: "bold",
          fontFamily: '"Noto Serif JP", serif',
          textAlign: "center",
        }}
      >
        {t("chi:error.episode_error")}
      </Typography>
    </Box>
  );
}

export default ChiEpisodeError;
